
import DashboardLayout from "../components/DashboardLayout";
import OverviewTab from "../components/DashboardPage/OverviewTab";
import DetailTabs from "../components/DashboardPage/DetailTabs";

const DashboardPage = () => {
 
  return (
    <DashboardLayout>
      <div className="flex w-full py-10 px-10 gap-7 md:flex-nowrap flex-wrap">
        <div className="w-full flex flex-col gap-7">
          <OverviewTab />
          <DetailTabs />         
        </div>
      </div>
    </DashboardLayout>
  );
};

export default DashboardPage;
